export default "__VITE_ASSET__85d59324__"